import React, { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import "./index.css";
import ControlPanel from "./components/ControlPanel";
import ScorePanel from "./components/ScorePanel/ScorePanel";
import type { RankingContext, ScoreBreakdown } from "./repo/rank";

mapboxgl.accessToken = process.env.BUN_PUBLIC_MAPBOX_ACCESS_TOKEN;

export function App() {
    const mapContainer = useRef<HTMLDivElement>(null);
    const map = useRef<mapboxgl.Map>(undefined);
    const rankingContextRef = useRef<RankingContext>({
        stack_rank: [],
    });
    const [selectedScore, setSelectedScore] = useState<ScoreBreakdown | null>(
        null,
    );

    useEffect(() => {
        if (map.current) return;
        if (!mapContainer.current) return;

        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/dark-v11",
            center: [0.8919, 51.8959],
            zoom: 12,
            projection: "mercator",
            transformRequest: (url, resourceType) => {
                if (!url.includes("api.mapbox.com")) {
                    if (
                        resourceType === "Tile" &&
                        (url.includes("/tiles/rank/") ||
                            url.includes("/tiles/rank_places/") ||
                            url.includes("/tiles/rank_properties/"))
                    ) {
                        return {
                            url,
                            method: "POST" as const,
                            headers: {
                                "Content-Type": "application/json",
                                "X-API-KEY":
                                    process.env.BUN_PUBLIC_TILE_SERVER_API_KEY,
                            },
                            body: JSON.stringify(rankingContextRef.current),
                        };
                    }
                    return {
                        url,
                        headers: {
                            "Content-Type": "application/json",
                            "X-API-KEY":
                                process.env.BUN_PUBLIC_TILE_SERVER_API_KEY,
                        },
                    };
                }
                return { url };
            },
        });
    }, []);

    return (
        <>
            <div ref={mapContainer} className="map-container" />
            <ControlPanel
                map={map}
                rankingContextRef={rankingContextRef}
                onSelectScore={setSelectedScore}
            />
            <ScorePanel
                score={selectedScore}
                onClose={() => setSelectedScore(null)}
            />
        </>
    );
}

export default App;
